import { string, object } from 'yup';

const schema = object().shape({
  time: string().nullable().required('Time is required')
});

export default schema;
